<template>
  <page class="home-page">
    <zui-header></zui-header>
    <router-view />
    <Backtop></Backtop>
    <zui-footer />
  </page>
</template>
<script>
import "../views/less/home-page.less";
import Page from "../components/Page";
import ZuiHeader from "../components/Header";
import ZuiFooter from "../components/Footer";
import Backtop from "./back_top.vue";
import Util from "../Util";
export default {
  components: { Page, ZuiHeader, ZuiFooter, Backtop },
  data() {
    return {
      carouselPerPage: Util.os.android || Util.os.iPhone ? 1 : 2
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/components/App.vue